import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable } from 'rxjs'

import { environment } from '@env'
import { ignoreTenant } from '@core/requests/tenant.interceptor'
import { TranslationObject } from '@ngx-translate/core'

@Injectable()
export class I18nApi {
  readonly #http = inject(HttpClient)

  fetchTranslations(language: string): Observable<{ translations: TranslationObject }> {
    return this.#http.get<{ translations: TranslationObject }>(
      environment.API.TRANSLATIONS(language),
      {
        context: ignoreTenant(),
      },
    )
  }
}
